import React from 'react';
import PropTypes from 'prop-types';
import Divider from '@mui/material/Divider';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

/**
 * Genera un componente [card simple](https://material-ui.com/components/cards/) con la información del parametro value y la configuración proporcionada.
 *
 * Cualquier otra propiedad proporcionada sera controlada por el elemento raiz [Card](https://material-ui.com/api/card/).
 */
function CardObjeto(props) {
   const {value, titulo, configuracion, ...other} = props;
   return (
      <Card {...other}>
         <CardContent>
            {titulo && (
               <>
                  <Typography gutterBottom variant="h5" component="h2">
                     {titulo}
                  </Typography>
                  <Divider />
               </>
            )}
            {configuracion.map((item, index) => {
               return (
                  <Typography key={index} variant="body2" component="p">
                     {item.label || item.name}: {value && value[item.name]}
                  </Typography>
               );
            })}
         </CardContent>
      </Card>
   );
}

CardObjeto.propTypes = {
   /**
    * Objeto a representar.
    */
   value: PropTypes.object,
   /**
    * Titulo del objeto
    */
   titulo: PropTypes.string,
   /**
    * Configuración de las propiedades a mostrar.
    *
    * `.name`: Nombre de la propiedad del objeto en `@value`
    *
    * `.label`: Texto a mostrar `value`
    */
   configuracion: PropTypes.arrayOf(
      PropTypes.shape({
         name: PropTypes.string.isRequired,
         label: PropTypes.string
      })
   )
};

export default CardObjeto;
